import { Control, UseFormWatch } from 'react-hook-form'
import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { MIN_VALUE_LABELS, MIN_VALUE_DESCRIPTIONS } from '../constants'
import type { NotificationItemFormData } from '../types'

interface MinValueFieldProps {
	control: Control<NotificationItemFormData>
	watch: UseFormWatch<NotificationItemFormData>
}

export default function MinValueField({ control, watch }: MinValueFieldProps) {
	const eligibilityType = watch('eligibilityType')

	return (
		<FormField
			control={control}
			name="minValue"
			render={({ field }) => (
				<FormItem>
					<FormLabel required>
						{MIN_VALUE_LABELS[eligibilityType] || 'ค่าขั้นต่ำ'}
					</FormLabel>
					<FormControl>
						<Input
							type="number"
							{...field}
							value={field.value || ''}
							onChange={(e) =>
								field.onChange(
									e.target.value ? Number(e.target.value) : undefined,
								)
							}
							placeholder="0"
						/>
					</FormControl>
					<FormDescription>
						{MIN_VALUE_DESCRIPTIONS[eligibilityType] ||
							'แสดงรายการนี้เฉพาะเมื่อมีค่ามากกว่าที่กำหนด'}
					</FormDescription>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
